import React,{useState,useEffect} from 'react'
import {Box } from 'grommet'
import { withRouter } from 'react-router-dom';
import AccountForm from '../../../components/accountForm'
import { API,Auth } from 'aws-amplify';
import { NavigationSnackBar,ReturnAddress,LoadLayer} from '../../../components/utils/shared/shared';
import {APIRequest} from '../../../components/utils/shared/requests'

function AdminEditAddress (props) {
  const [address, setAddress] = useState();
  const [load, setLoad] = useState(true); 
    useEffect(() => { 
      APIRequest(`/addresses/${props.match.params.address_id}`).then(result => {setAddress(result); setLoad(false)})
    },[]);


    const handleSubmit = () => {
        setLoad(true)
        const updatedAddress = ReturnAddress(address, 'address', 'edit')
        Auth.currentSession().then(session => {
          API
          .put("LabShip", `/addresses/${address.id}`,
          { headers: { 
            Authorization: session.idToken.jwtToken,
          }, 
          body:{address: updatedAddress}})
          .then(shipment => {
            setLoad(false)
            props.history.push({pathname:'/admin/addresses/all', edit:true, addressSuc: true})
         })
        })
      }
  return (
   <Box background={'light-1'}>
      {(load ? <LoadLayer load={load} label={'Loading Address'} />: 
      <Box>
        <NavigationSnackBar title={`${address.name}`} user={props.user} pages={[{name: 'Dashboard',link: '/dashboard'},{name: 'Addresses', link: '/addresses/all'}]}  />
        <Box alignSelf='center' elevation='medium' direction='column' margin='small' round >
        <AccountForm label="Update Address"  value={address}  user={props.user} account={address} lab={address} load={load} handleSubmit={handleSubmit} setAccount={setAddress} />
        </Box>
      </Box>
      )}
   </Box>
  )
}

export default withRouter(AdminEditAddress)
